import React from 'react';
import { Box } from '@mui/material';
import { MicrosoftAzure } from 'utils/icons/integrationsSvgIcons';

const TeamV2MicrosoftIconStyled = ({ size = '1.25rem', marginRight = '1rem' }) => {
    return (
        <Box sx={{
            width: size,
            height: size,
            filter: 'grayscale(100%) brightness(1.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: marginRight,
            flexShrink: 0
        }}>
            <MicrosoftAzure sx={{
                width: '100%',
                height: '100%'
            }} />
        </Box>
    );
};

export default TeamV2MicrosoftIconStyled;
